import React, { useState } from 'react';
import { authService } from '../services/api';
import { API_VERSION, FRONT_VERSION } from '../version';

interface LoginProps {
  onLogin: (token: string, nome: string) => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await authService.login(email, password);
      onLogin(response.token, response.usuario?.nome || '');
    } catch (err: any) {
      setError(err.response?.data?.message || 'Erro ao fazer login. Verifique suas credenciais.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid vh-100 d-flex align-items-center justify-content-center" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      <div className="row w-100 justify-content-center">
        <div className="col-md-6 col-lg-4">
          <div className="card shadow-lg border-0">
            <div className="card-body p-5">
              <div className="text-center mb-4">
                <i className="fas fa-graduation-cap fa-3x text-primary mb-3"></i>
                <h2 className="card-title text-dark">Horus</h2>
                <p className="text-muted">Sistema de Gerenciamento Escolar</p>
              </div>
              
              {error && (
                <div className="alert alert-danger" role="alert">
                  <i className="fas fa-exclamation-triangle me-2"></i>
                  {error}
                </div>
              )}
              
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label text-start d-block">
                    <i className="fas fa-envelope me-2"></i>Email
                  </label>
                  <input
                    type="email"
                    className="form-control form-control-lg"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Digite seu email"
                    required
                    disabled={loading}
                  />
                </div>
                
                <div className="mb-4">
                  <label htmlFor="password" className="form-label text-start d-block">
                    <i className="fas fa-lock me-2"></i>Senha
                  </label>
                  <input
                    type="password"
                    className="form-control form-control-lg"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Digite sua senha"
                    required
                    disabled={loading}
                  />
                </div>
                
                <button
                  type="submit"
                  className="btn btn-primary btn-lg w-100"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Entrando...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-sign-in-alt me-2"></i>
                      Entrar
                    </>
                  )}
                </button>
              </form>
              
              {/* Seção de Contato */}
              <div className="text-center mt-4 pt-3 border-top">
                <h6 className="text-muted mb-3">
                  <i className="fas fa-headset me-2"></i>
                  Precisa de ajuda?
                </h6>
                <div className="d-flex flex-column gap-2">
                  <div className="d-flex align-items-center justify-content-center">
                    <i className="fas fa-envelope text-primary me-2"></i>
                    <a href="mailto:contato@fikra.com.br" className="text-decoration-none text-dark">
                      contato@fikra.com.br
                    </a>
                  </div>
                  <div className="d-flex align-items-center justify-content-center">
                    <i className="fab fa-whatsapp text-success me-2"></i>
                    <span className="text-dark me-2">(41) 4042-9882</span>
                    <a 
                      href="https://wa.me/5541404299882" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="btn btn-success btn-sm px-3 py-1"
                      style={{ fontSize: '0.8rem' }}
                    >
                      <i className="fab fa-whatsapp me-1"></i>
                      WhatsApp
                    </a>
                  </div>
                </div>
              </div>
              
              <div className="text-center mt-3">
                <small className="text-muted">
                  © 2025 Horus - Sistema de Gerenciamento Escolar
                </small>
                <br />
                <small className="text-muted">
                  Desenvolvido por <a href="https://fikra.com.br" target="_blank" rel="noopener noreferrer" className="text-decoration-none">Fikra Creative Studio</a>
                </small>
                <br />
                <small className="text-muted">
                  Versão: api {API_VERSION} e front {FRONT_VERSION}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;